import { render, staticRenderFns } from "./Articleblock.vue?vue&type=template&id=cd9974d2"
import script from "./Articleblock.vue?vue&type=script&lang=js"
export * from "./Articleblock.vue?vue&type=script&lang=js"
import style0 from "./Articleblock.vue?vue&type=style&index=0&id=cd9974d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports